(function () {
  var STORAGE_KEY = 'daylight-shop-theme';
  var VALID = ['light', 'dark'];
  var html = document.documentElement;

  function current() {
    return html.getAttribute('data-theme') || 'light';
  }

  function apply(mode) {
    if (VALID.indexOf(mode) === -1) return;
    html.setAttribute('data-theme', mode);
    try { localStorage.setItem(STORAGE_KEY, mode); } catch (e) {}
    syncButtons();
  }

  function syncButtons() {
    var active = current();
    document.querySelectorAll('[data-theme-set]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.dataset.themeSet === active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-theme-set]');
    if (!btn) return;
    e.preventDefault();
    apply(btn.dataset.themeSet);
  });

  syncButtons();
})();
